import React from 'react';
import { Badge } from 'reactstrap';

/**
 * Componente para mostrar alertas con colores según el nivel
 * 
 * @param {Object} alerta - Objeto con nivel y color del backend
 * @param {string} size - Tamaño del badge (sm, md, lg)
 * @param {boolean} showIcon - Mostrar icono
 * @param {boolean} showText - Mostrar texto del nivel
 */
const AlertaBadge = ({ alerta, size = 'sm', showIcon = true, showText = false }) => {
  if (!alerta || !alerta.color) return null;

  // Mapeo de colores del backend a colores de Bootstrap
  const colorMap = {
    'verde': 'success',
    'amarillo': 'warning',
    'rojo': 'danger'
  };

  // Mapeo de iconos según el nivel
  const iconMap = {
    'excelente': 'ri-checkbox-circle-fill',
    'normal': 'ri-checkbox-circle-fill',
    'aceptable': 'ri-error-warning-fill',
    'advertencia': 'ri-error-warning-fill',
    'critico': 'ri-close-circle-fill'
  };

  // Mapeo de textos en español
  const textMap = {
    'excelente': 'Excelente',
    'normal': 'Normal',
    'aceptable': 'Aceptable',
    'advertencia': 'Advertencia',
    'critico': 'Crítico'
  };

  const bootstrapColor = colorMap[alerta.color] || 'secondary';
  const icon = iconMap[alerta.nivel] || 'ri-information-fill';
  const text = textMap[alerta.nivel] || alerta.nivel;

  // Clases de tamaño
  const sizeClass = size === 'lg' ? 'fs-6 px-3 py-2' : 
                    size === 'md' ? 'fs-7 px-2 py-1' : 
                    'fs-8 px-2 py-1';

  return (
    <Badge 
      color={bootstrapColor} 
      className={`${sizeClass} d-inline-flex align-items-center gap-1`}
      pill
    >
      {showIcon && <i className={`${icon} fs-6`}></i>}
      {showText && <span>{text}</span>}
    </Badge>
  );
};

export default AlertaBadge;
